// extracted by mini-css-extract-plugin
export default {"root":"style_root__7o4TM","count":"style_count__sZVJz","text":"style_text__+UMhx","positive":"style_positive__5GLeD","negative":"style_negative__6GpSH"};